import * as Utils from "../utils/Config";
import { AuthContextModel } from '../App'
import { ApiClient } from "./ApiClient";
import { IRiskPotReportTreatment, IEditRiskPotReportTreatment } from "../models/IRiskPotReport";
import { IPatientTreatment } from "../models/IPatientTreatment";
import { ICarePerformer } from "../models/ICarePerformer";

export class RiskPotReportTreatmentReportingApi extends ApiClient {
    constructor(auth: AuthContextModel) {
        super(auth);
    }

    saveTreatment(data: IRiskPotReportTreatment, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/riskPotReportTreatmentReporting/saveTreatment`, data, success, error, final);
    }

    getTreatments(treatmentDate: Date, carePerformerId: number, success: (riskPotReport: IPatientTreatment[]) => void, error?: (message: string) => void, final?: () => void) {
        var tempDate = new Date(treatmentDate);
        tempDate.setTime(tempDate.getTime() - tempDate.getTimezoneOffset() * 60 * 1000);
        var treatmentDateString = tempDate.toUTCString();
        this.get(`${Utils.LIB_API_BASE_URL}/riskPotReportTreatmentReporting/treatments/${treatmentDateString}/${carePerformerId}`, success, error, final);
    }

    getCarePerformersAllowedForTreatmentCode(treatmentCode: string, date: string, success: (data: ICarePerformer[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICarePerformer[]>(`${Utils.LIB_API_BASE_URL}/riskPotReportTreatmentReporting/getCarePerformersAllowedForTreatmentCodeWithDate/${treatmentCode}/${date}`, success, error, final);
    }

    removeTreatment(patientTreatmentId: number, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.delete(`${Utils.LIB_API_BASE_URL}/riskPotReportTreatmentReporting/treatment/${patientTreatmentId}`, success, error, final);
    }

    editTreatment(data: IEditRiskPotReportTreatment, success: () => void, error?: (message: string) => void, final?: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/riskPotReportTreatmentReporting/editTreatment`, data, success, error, final);
    }

    creditTreatment(riskPotReportPatientTreatmentId: number, success: () => void) {
        this.post(`${Utils.LIB_API_BASE_URL}/riskPotReportTreatmentReporting/creditTreatment/${riskPotReportPatientTreatmentId}`, undefined, success);
    }
}

